import { Button, DatePicker } from 'antd';

import { DATE_PICKER_FORMAT, rangePickerLocale } from '@app/constants';

import { useTasksPeriodPicker } from './hooks/useTasksPeriodPicker';

import type { TasksPeriod } from './types';
import type { RangePickerProps } from 'antd/es/date-picker';
import type { PickerLocale } from 'antd/es/date-picker/generatePicker';
import type { FC } from 'react';

import './TasksPeriodPicker.scss';

const { RangePicker } = DatePicker;

const PF = 'TasksPeriodPicker';

// value и onChange передаёт Form.Item поля Date.
interface TasksPeriodPickerProps {
  value?: TasksPeriod | null;
  onChange?: RangePickerProps['onChange'];
  onSave(period: TasksPeriod | undefined): void;
}

export const TasksPeriodPicker: FC<TasksPeriodPickerProps> = ({
  value,
  onChange,
  onSave,
}) => {
  const { isOpen, openChangeHandler, calendarChangeHandler, saveHandler } =
    useTasksPeriodPicker({ value, onSave });

  return (
    <RangePicker
      className={PF}
      format={DATE_PICKER_FORMAT}
      size="middle"
      allowEmpty={[true, true]}
      locale={rangePickerLocale as PickerLocale}
      value={value}
      open={isOpen}
      onChange={onChange}
      onOpenChange={openChangeHandler}
      onCalendarChange={calendarChangeHandler}
      renderExtraFooter={() => (
        <div className={`${PF}__footer`}>
          <Button
            type="primary"
            size="small"
            data-testid="tasks-period-save"
            onClick={saveHandler}
          >
            Сохранить
          </Button>
        </div>
      )}
    />
  );
};
